module.exports = __webpack_public_path__ + "img/waterNormals.4fff67aa.jpg";